import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const SupplierCellEm = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const SupplierCellValue = styled.span`
  font-size: ${tokens.font.body};
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const SupplierVariance = styled.span<{ $warn?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: ${({ $warn }) => ($warn ? tokens.status.warning.fg : tokens.text.secondary)};
`

export const SupplierOpenClaims = styled.span<{ $open?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: ${({ $open }) => ($open ? 600 : 400)};
  font-variant-numeric: tabular-nums;
  color: ${({ $open }) => ($open ? tokens.status.warning.fg : tokens.text.secondary)};
`
